module.exports = __webpack_public_path__ + "static/media/icono-alimentacion.57e2d3b6.svg";